<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-input class="addART"
                @change="skipPage(1)"
                placeholder="搜索药品名称"
                v-model="page.name">
        <i style="cursor: pointer" slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-tabs value="全部" class="tabs" @tab-click="handleClick">
        <el-tab-pane :name="obj" :label="obj" v-for="(obj,ind) in consultJson" :key="ind">
          <div class="typeHead" v-if="isFirstLoad">
            <div class="medicineType flex" style="align-items: start;">
              <span class="typeTit">药物类别：</span>
              <div class="medicineTypeL drug-block">
                <div class="category-img" v-for="(item,index) in categories" :key="index"
                     @click="changeFirst(index+1,item.id,1)">
                  <div><img :src="item.iconPath" :alt="item.cnName"></div>
                  <div>{{ item.cnName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="typeHead" v-if="!isFirstLoad">
            <div class="medicineType flex">
              <span class="typeTit">药物类别：</span>
              <div class="medicineTypeL">
                <span><label :class="active.categoryIndex==0?'activeClass':''" @click="change(0,0,1)">不限</label></span>
                <span v-for="(item,index) in categories" :key="index">
                                    <label :class="active.categoryIndex==index+1?'activeClass':''"
                                           @click="change(index+1,item.id,1)">{{ item.cnName }}</label>
                                </span>
              </div>
            </div>
          </div>

          <div class="typeCon" v-if="!isFirstLoad">
            <div v-if="page.total==0" style="text-align: center;color: #DFE0E7;width: 100%">
              <img src="../../assets/img/empty_tips.png" alt="" style="width: 320px;">
              <div>暂无数据</div>
            </div>

            <div class="drug flex" v-for="(obj ,ind) in page.rows" :key="ind">

              <div v-if="obj.thumbnailPath" :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="img ">
                <span v-if="obj.drugType === 1">新药</span>
              </div>
              <div v-else class="img" style="background-image:url('/static/default_imgs/drug.jpg')">
                <span v-if="obj.drugType === 1">新药</span>
              </div>

              <div class="rightC">
                <h3>{{ obj.cnName }}</h3>
                <span> {{ obj.enName }}</span>
                <p>{{ obj.briefDesc }}</p>
                <el-button size="mini" @click="toDetail(obj.id)">了解更多</el-button>
              </div>
            </div>

            <div style="width: 100%;text-align: center">
              <el-pagination
                  class="pagination"
                  background
                  :hide-on-single-page="true"
                  prev-text="Prev"
                  next-text="Next"
                  @current-change="skipPage"
                  :current-page="page.current"
                  :page-size="page.size"
                  layout="prev, pager, next, total"
                  :total="page.total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "medication",
  data() {
    return {
      isFirstLoad: true,
      categories: [],
      indications: [],
      active: {
        categoryIndex: 0,
        indicationIndex: 0,
      },
      page: {
        current: 1,
        size: 10,
        total: 16,
        rows: [],

        category: '',
        indication: '',
        name: ''
      },

      consultJson: ['全部'],
      userId: '',
    }
  },
  async mounted() {
    let currentUser = await base.utils.getCurrent();//获取当前登录的用户id
    if (currentUser != null) {
      this.getUserId = currentUser.id;
    }
    this.getUser();//当前用户
    /*
    try {
      this.$parent.$refs.headerRef.active = 4;
    } catch (e) {
      console.error(e);
    }*/
    // 1.load category
    this.$ajax.get(base.api.drug.category.simple_all).then((res) => {
      if (res.data.status === 'success') {
        this.categories = res.data.list;
      }
    });

    // 2.load indication
    /*
        this.$ajax.get(base.api.indication.types.simple_all).then((res) => {
            if (res.data.status === 'success') {
                this.indications = res.data.list;
            }
        });
    */
    // 3.load drugs
    // this.getData();

  },
  methods: {
    getData() {
      this.$ajax.get(base.api.drug.page, {
        params: {
          page: this.page.current,
          size: this.page.size,
          name: this.page.name,
          categoryId: this.page.category,
          indicationId: this.page.indication,
          userId: this.userId
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        }
      });
      //document.querySelector('.homeIndex').scrollTop = 0;//回到顶部
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
    changeFirst(index, id, type) {
      this.isFirstLoad = false;
      this.change(index, id, type);
    },
    change(index, id, type) { //type: 1-category 2-indication
      this.page.current = 1; //页码重置
      if (type === 1) {
        this.active.categoryIndex = index;
        this.page.category = id;
      } else if (type === 2) {
        this.active.indicationIndex = index;
        this.page.indication = id;
      }
      this.getData();
    },
    toDetail(id) {
      this.$router.push({name: 'medicationDetail', query: {id: id}});
    },
    //获得当前用户id
    getUser() {
      if (this.getUserId) {
        this.consultJson = ['全部', '我的关注']
      } else {
        this.consultJson = ['全部']
      }
    },
    //全部/我的 点击事件
    handleClick(tab) {
      if (tab.name === "我的关注") {
        this.userId = this.getUserId;
        this.getData();
      } else {
        this.userId = null;
        this.getData();
      }
    },
  }
}
</script>


<style scoped lang="scss">
@import '../../assets/css/medication.scss';

.drug-block {
  .category-img {
    display: block;
    width: 170px;
    height: 138px;
    float: left;
    box-sizing: border-box;
    margin: 0 40px;
    text-align: center;
    cursor: pointer;

    img {
      width: 140px;
      max-height: 100px;
    }
  }
}

</style>
